export default __webpack_public_path__ + "3552be4fe5d75d175961228b91518c7d.png";